import { Card, Typography, message, Space, Checkbox, Alert, Divider } from "antd";
import { useEffect, useState } from "react";
import { getVagasDisponiveis, addCurriculosVagas } from "../../api/vagas";
import { InfoCircleOutlined } from "@ant-design/icons";
const { Text } = Typography;

const HomeVagas = () => {
  const [dados, setDados] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    listar();
  }, []);

  const listar = async () => {
    setLoading(true);
    try {
      const retorno = await getVagasDisponiveis();
      if (retorno?.statusCode === 200) {
        setDados(retorno?.response?.data);
      } else {
        message.error(retorno?.response?.message);
      }
    } catch (error) {
      message.error("Não foi possível atender a requisição!");
    }
    setLoading(false);
  };

  const salvarVagas = async (checked, vagas) => {
    setLoading(true);

    const dados_envio = {
      id_vagas: vagas,
      id_vagas_checked: checked,
    };

    try {
      const retorno = await addCurriculosVagas(dados_envio);
      if (retorno?.statusCode === 200) {
        let array_dados = dados;

        vagas?.forEach((element) => {
          const index = array_dados?.findIndex((e) => e?.id === element);
          if (index >= 0) {
            array_dados[index]["checked"] = false;
          }
        });

        checked?.forEach((element) => {
          const index = array_dados?.findIndex((e) => e?.id === element);
          if (index >= 0) {
            array_dados[index]["checked"] = true;
          }
        });

        setDados(array_dados);
      } else {
        message.error(retorno?.response?.message);
      }
    } catch (error) {
      message.error("Não foi possível atender a requisição!");
    }
    setLoading(false);
  };

  const handleChange = (value, id) => {
    if (loading) return;
    salvarVagas([value && id], [id]);
  };

  return (
    <Card title={<Text className="title-middle">Vagas</Text>} className="shadow">
      <Space direction="vertical" className="full-width">
        <Text type="secondary">
          <InfoCircleOutlined /> As vagas são atualizadas conforme a disponibilidade.
        </Text>
        <Divider style={{ margin: 0 }} />

        {dados?.map((e) => {
          return (
            <Checkbox
              key={e?.id}
              checked={e?.checked}
              onChange={(val) => handleChange(val?.target?.checked, e?.id)}
              value={e?.id}>
              {e?.descricao}
            </Checkbox>
          );
        })}

        {dados?.length === 0 && (
          <Alert message="Atenção" description="Não há vagas dinsponíveis no momento" type="info" showIcon />
        )}
      </Space>
    </Card>
  );
};

export { HomeVagas };
